<template>
    <div>
        <gofix-card class="mb-0" fullContent>
            <gofix-default-table 
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @new-item="addItem"
                @delete-items="deleteItems"
                @row-click="showDetail"
                @change-selected="getIdSelected"
                @clone-master="cloneData"
                ref="gofixTable">
                <template slot="gofix_table:skips_holiday" slot-scope="row">
                    <img width="12px" src="img/check.png" alt="" v-if="row.item.skips_holiday"/>
                </template>
                <template slot="gofix_table:root_path" slot-scope="row">
                    {{ row.item.location_info ? row.item.location_info.root_path : '--' }}
                </template>
                <template slot="gofix_table:start_date" slot-scope="row">
                    {{row.item.start_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                </template>
                <template slot="gofix_table:end_date" slot-scope="row">
                    {{row.item.end_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                </template>
                <template slot="gofix_table:name_service" slot-scope="row">
                    {{  row.item.get_category ? row.item.get_category.name : ''}}
                </template>
                <template slot="gofix_table:recurring_mode" slot-scope="row">
                    {{row.item.get_sor_recurring_mode ? row.item.get_sor_recurring_mode.recurring_mode : ''}}
                </template>
                <template slot="gofix_table:name" slot-scope="row">
                    {{row.item.get_equipment_structure ? row.item.get_equipment_structure.name : ''}}
                </template>
                <template slot="gofix_table:equipment_list" slot-scope="row">
                    {{row.item.equipment_list | eqlTable}}
                </template>
                <template slot="gofix_table:row-details" slot-scope="row" >
                    <div class="expandTable maintenanceScheduleDetail" @click="showDetail(row.item)">
                        <p class="title">Full Equipments</p>
                        <p>{{row.item.equipment_list | eqlTableFull}}</p>
                    </div>
                </template>
                <template slot="gofix_table:property_list" slot-scope="row">
                    {{row.item.property_list | eqlTable}}
                </template>
                <template slot="gofix_table:group_supplier" slot-scope="row">
                    <div v-if="row.item.group_supplier.length === 0"></div>
                    <div v-else>{{ row.item.group_supplier.map(s => s.supplier).filter(Boolean).join(', ') }}</div>
                    <!-- <div v-else v-for="(item, key) in row.item.group_supplier" :key="key">
                        <div v-if="key === (row.item.group_supplier.length - 1)">
                            {{item.supplier}}
                        </div>
                        <div v-else>
                            {{item.supplier + ', '}}
                        </div>
                    </div> -->
                </template>
                <template slot="gofix_table:joblist_order_count" slot-scope="row">
                    {{row.item.joblists_count && row.item.joblists_count !== 0 ? 'Yes' : 'No'}}
                </template>
            </gofix-default-table>

            <b-modal :no-close-on-backdrop="true" ref="modal-equipment" class="modal-schedule-detail" hide-footer hide-header :centered="true" id="modal-custom-maint-v2" v-model="modals.create">
                <div class="modal-left float-left boxGg boxInfo" v-bind:class="{'modal-left-location':!(sorItem.equipment_structure_type)}">
                    <b-form class="formV2">
                        <b-row class="content scheduleInfo">
                            <b-col md="12 mb-20">
                                <div class="title">Schedule Detail</div>
                            </b-col>
                            <b-col md="12 mb-10" v-if="sorItem.service_category">
                                <p class="mb-0"><span class="opacity-06">Service Category </span><span>{{ sorItem.service_category.name || '' }}</span></p>
                            </b-col>
                            <b-col md="12 mb-10" v-if="sorItem.equipment_structure_type">
                                <p class="mb-0"><span class="opacity-06">Equipment Group </span><span>{{ sorItem.equipment_structure_type.name || '' }}</span></p>
                            </b-col>
                            <b-col md="12 mb-10">
                                <p class="mb-0"><span class="opacity-06">Frequency </span><span>{{ sorItem.get_sor_recurring_mode && sorItem.get_sor_recurring_mode.recurring_mode ? sorItem.get_sor_recurring_mode.recurring_mode : '--' }}</span></p>
                            </b-col>
                            <b-col md="12 mb-10">
                                <p class="mb-0"><span class="opacity-06">Tolerance </span><span>{{ sorItem.tolerance_period  || 0 }} days</span></p>
                            </b-col>
                            <b-col md="6" class="mb-30 mt-20">
                                <gofix-form-input-date
                                        v-model="startDate"
                                        label="Start Date">
                                </gofix-form-input-date>
                            </b-col>
                            <b-col md="6" class="mb-30  mt-20">
                                <gofix-form-input-date
                                        v-model="endDate"
                                        label="End Date"
                                        popoverAlign="right"
                                        >
                                </gofix-form-input-date>
                            </b-col>
                            <b-col md="12">
                                <b-form-checkbox
                                        id="checkbox-1"
                                        v-model="holiday"
                                        name="checkbox-1"
                                        class="text-light-back"
                                        value="1"
                                >
                                    Skip holidays?
                                </b-form-checkbox>
                            </b-col>
                            <b-col md="12" class="mt-4">
                                <gofix-form-input label="Description" v-model="description"></gofix-form-input>
                            </b-col>
                        </b-row>
                    </b-form>
                </div>
                <div class="modal-tree-location float-left boxGg" v-if="!(sorItem.equipment_structure_type)">
                    <div class="title text-dark">Property </div>
                    <div class="content contractTree">
                        <div class="tree-view-properties">
                            <gofix-form-properties 
                                label="Location" 
                                :property-id="rootIds ? rootIds.property_root : null" 
                                valueFormat="object"  
                                v-model="properties" 
                                :show-icon-required="true" 
                                :multiple="true"
                                :alwaysOpen="true"
                                :flat="true"
                                :defaultExpandLevel="1"
                                :maxHeight="350"
                                :limit="0"
                                :limitText="count => `${count} items selected.`"
                                :sortValueBy="'INDEX'"
                                :disableRootCluster="true"
                                class="gofixInputNoMinWidth text-normal">
                            </gofix-form-properties>
                        </div>
                    </div>
                </div>
                <div class="modal-right-location float-left boxGg" v-if="!(sorItem.equipment_structure_type)">
                    <div class="title text-dark"> Selected Locations </div>
                    <div class="bottomDiv selected-location">
                        <ul class="list-unstyled">
                            <li v-for="item in properties" :key="item.id" >
                                <span v-bind:title="item.root_path">{{item.name}}</span>
                            </li>

                        </ul>
                    </div>
                </div>
                <div class="modal-tree float-left boxGg"  v-if="sorItem.equipment_structure_type">
                    <div class="title text-dark">Equipment Filter By Property</div>
                    <div class="content contractTree">
                        <div class="tree-view-properties">
                            <tree ref="tree" :data="treeData" :options="optsLocation" @node:clicked="selectLocation">
                                <div slot-scope="{ node }" class="node-container"> {{ node.text }} </div>
                            </tree>
                        </div>
                    </div>
                </div>
                <div class="modal-right float-left boxGg"  v-if="sorItem.equipment_structure_type">
                    <div class="bottomDiv" v-bind:class="{'run-loading':loadings.equipment}" >
                        <ul class="list-unstyled listCheck listCheckDefault">
                            <li>
                                <input class="styled-checkbox" type="checkbox" @change="selectAll" v-model="checkAll">
                                <label></label>
                                <span>Select Equipments</span>
                            </li>
                            <!-- <li v-if="!sorItem.equipment_group_id">No Equipment</li> -->
                            <li v-for="(item,idx) in listItemEquipment" :key="idx" >
                                <input :true-value="1" :false-value="0" value="1" v-model="item.status" :checked="item.status == 3 ? false : (item.status == 1 ? true : false)" @click="addListEquipment(item)" class="styled-checkbox" :disabled="item.status==3" type="checkbox">
                                <label ></label>
                                <span>{{item.tag_name}}</span>
                            </li>

                        </ul>
                    </div>
                </div>
                <b-button-group class="d-block text-right pr-4 clear-both mb-3">
                    <gofix-button label="CANCEL" @click="modals.create = false" noBorder dark></gofix-button>
                    <gofix-button label="SAVE" @click="save" :loading="isAction" noBorder></gofix-button>
                </b-button-group>
            </b-modal>

            <!--Modals-->
            <b-modal :no-close-on-backdrop="true" id="modal-assign-schedule" title="Assign To Jobs" hide-footer :centered="true" v-model="modals.assign.open" ref="modalSupplierAssign">

                <b-form class="pb-20">
                    <b-row class="mb-20">
                        <b-col class="mb-20" md="12">
                            <div class="title label-container-radio-title"> Do you want to pre-assign jobs to a Supplier?</div>
                        </b-col>
                        <b-col md="3">
                            <label class="label-container-radio">Yes
                                <input v-model="modals.assign.checksupplierAssign" :checked="true" value="Yes" type="radio" name="radio">
                                <span class="checkmark"></span>
                            </label>
                        </b-col>
                        <b-col md="3">
                            <label class="label-container-radio">No
                                <input v-model="modals.assign.checksupplierAssign" value="No" type="radio" name="radio">
                                <span class="checkmark"></span>
                            </label>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <gofix-form-supplier
                                    :disabled="modals.assign.checksupplierAssign === 'No'"
                                    label="Supplier Name"
                                    :contract-id="rootIds.contract_id ? Number(rootIds.contract_id) : ClientContractID ? Number(ClientContractID.id) : null"
                                    v-model="modals.assign.supplierAssign">
                            </gofix-form-supplier>
                        </b-col>
                        
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <gofix-form-dropdown label="Choose FM Team" vLabel="group_name"
                                :options="fm_group_options" 
                                v-model="modals.assign.team_in_charge"
                                 @change="FMTeamChange"
                                >
                            </gofix-form-dropdown>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="12">
                            <gofix-form-dropdown
                                label="Choose FM Staff"
                                vLabel="user_name"
                                v-model="modals.assign.staff_in_charge"
                                :options="fm_staff_options"
                                @search="getFMStaff" 
                                v-bind:class="{'run-loading small-loading':modals.assign.loading_fm_staff}"
                                >
                                <template #gofixInput:dropdown:option="{ user_name, role_name }">
                                        {{ user_name }} {{ (role_name ? "-" : "")}} {{ role_name }}
                                </template>
                                <template #gofixInput:dropdown:selected-option="{ user_name, role_name }">
                                    {{ user_name }} {{ (role_name ? "-" : "")}} {{ role_name }}
                                </template>
                            </gofix-form-dropdown>
                        </b-col>
                        <b-col md="12">
                            <b-form-checkbox
                                    id="checkbox-1"
                                    v-model="modals.assign.raise_work_order"
                                    name="checkbox-1"
                                    class="text-light-back"
                                    :value="true"
                            >
                                Generate PWO for each occurrence
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="CANCEL"  @click="$refs['modalSupplierAssign'].hide()" noBorder dark></gofix-button>
                    <gofix-button label="OK" @click="showModalInfoGenerate" :loading="modals.assign.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
            <b-modal :no-close-on-backdrop="true" id="modal-Remove" hide-footer hide-header :centered="true" v-model="modals.generateJob.open">
                <div class="py-4 px-1">
                    <p>
                        From <strong>{{modals.generateJob.data.count_maint_schedule}}</strong> maintenance schedule(s), the system will generates a total of <strong>{{modals.generateJob.data.count_jobs}}</strong> jobs 
                        <br>for <strong>{{modals.generateJob.data.count_occurrences}}</strong> occurrences and 
                        <br>for <strong>{{modals.generateJob.data.count_equipment_or_locations}}</strong> equipment/locations
                    </p>
                </div>
                <b-button-group class="btn-group">
                    <b-button class="custom-btn" @click="modals.generateJob.open = false">Cancel</b-button>
                    <b-button class="custom-btn" :disabled="modals.generateJob.loading" @click="updateRunsheet">
                        <b-spinner v-if="modals.generateJob.loading" type="grow" small></b-spinner> Generate
                    </b-button>
                </b-button-group>
            </b-modal>
            <b-modal :no-close-on-backdrop="true" hide-footer :centered="true" id="modal-Create" size="md" v-model="modals.clone.open" :title="modals.clone.title">
                <b-form class="formV2">
                    <b-row class="content scheduleInfo">
                        <b-col md="12 mb-10" v-if="sorItem.service_category">
                            <p class="mb-0"><span class="opacity-06">Service Category </span><span>{{ sorItem.service_category.name || '' }}</span></p>
                        </b-col>
                        <b-col md="12 mb-10" v-if="sorItem.equipment_structure_type">
                            <p class="mb-0"><span class="opacity-06">Equipment Group </span><span>{{ sorItem.equipment_structure_type.name || '' }}</span></p>
                        </b-col>
                        <b-col md="12 mb-10">
                            <p class="mb-0"><span class="opacity-06">Frequency </span><span>{{ sorItem.get_sor_recurring_mode && sorItem.get_sor_recurring_mode.recurring_mode ? sorItem.get_sor_recurring_mode.recurring_mode : '--' }}</span></p>
                        </b-col>
                        <b-col md="12 mb-10">
                            <p class="mb-0"><span class="opacity-06">Tolerance </span><span>{{ sorItem.tolerance_period  || 0 }} days</span></p>
                        </b-col>
                        <b-col md="6" class="mb-10 mt-20">
                            <gofix-form-input-date
                                v-model="startDate"
                                label="Start Date">
                            </gofix-form-input-date>
                        </b-col>
                        <b-col md="6" class="mb-10  mt-20">
                            <gofix-form-input-date
                                v-model="endDate"
                                label="End Date"
                                popoverAlign="right"
                                >
                            </gofix-form-input-date>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right pr-4 clear-both mb-3">
                    <gofix-button label="CLONE" @click="saveClone" :loading="modals.clone.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </gofix-card>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import LiquorTree from 'liquor-tree';
    import { filters } from '@/_filterVar.js'
    import moment from 'moment';
    const simulateAsyncOperation = fn => {
        setTimeout(fn, 500)
    }
    export default {
        name: 'maintenance-program-maintenance-schedule',
        components: {
            [LiquorTree.name]: LiquorTree,
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['maintenance_schedule']));
            return {
                queryParam: { id: this.$route.params.id },
                tableConfig:{
                    dataSelect: {
                        skips_holiday: {
                            value: [
                                {value: true, text: 'Yes'},
                                {value: false, text: 'No'}],
                            value_field: 'value',
                            text_field: 'text'
                        }
                    },
                    name: 'preventive-maintenance-schedule',
                    controls:{
                        create: true,//this.$checkRole(this.$accessModule.client_contract_program, 'create'),
                        disabled_create: false,
                        createTooptip: 'New',
                        delete: this.$checkRole(this.$accessModule.client_contract_program, 'delete')
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "id",
                    sortDirection: "asc",
                },
                tierLevel: 1,
                disabledJob: false,
                tableItems: [],
                startDate: null,
                property: null,
                properties: null,
                endDate: null,
                description: null,
                rootID: 0,
                treeData: [],
                optsLocation: {
                    minFetchDelay: 500,
                    fetchData: (node) => {
                        node.isBatch = false
                        return new Promise((resolve, reject) => {
                            global.axios(`api/contracts/${this.rootIds.contract_id}/tree-properties/${node.data.id}`, {
                                method: "GET",
                                params: {
                                    // is_active: true
                                },
                                headers: {
                                    Accept: "application/json",
                                }
                            })
                                .then(response => {
                                    resolve(response.data.data);
                                })
                                .catch(error => reject(error));
                        });
                    }
                },
                optsLocationMulti: [],
                // optionsSaw: [ {
                //     id: 'fruits',
                //     label: 'Fruits',
                //     children: [ {
                //         id: 'apple',
                //         label: 'Apple 🍎',
                //         isNew: true,
                //     }, {
                //         id: 'grapes',
                //         label: 'Grapes 🍇',
                //     }
                //     ],
                //     } ],
                nodeSelected: null,
                listItemEquipment: [],
                checkAll: 0,
                equipmentSelected: [],
                holiday: 1,
                itemsEquipmentSchedule: [],
                id: 0,
                check: false,
                isAction : false,
                modals:{
                    create:false,
                    delete:false,
                    assign:{
                        open:false,
                        loading: false,
                        supplier:[],
                        checksupplierAssign:'Yes',
                        supplierAssign: null,
                        ids: [],
                        raise_work_order: false,
                        filter: null,
                        time: null,
                        staff_in_charge: null,
                        team_in_charge: null,
                        loading_fm_staff: false,
                        property_ids: [],
                        service_category_ids: [],
                    },
                    generateJob: {
                        open: false,
                        loading: false,
                        data: {
                            count_maint_schedule: 0,
                            count_jobs: 0,
                            count_occurrences: 0,
                            count_equipment_or_locations: 0
                        }
                    },
                    clone: {
                        ids: [],
                        open: false,
                        loading: false,
                        title: 'Clone Schedule',
                        equipments_exclude: []
                    }
                },
                rootIds:{
                    contract_id : this.$route.params.id,
                    contract_term_id: null,
                    property_root: null,
                    end_date: null
                },
                loadings:{
                    equipment: false,
                    property:false
                },
                propertiesData:[],
                fm_staff_options: [],
                fm_group_options: [],
                timer_c: {
                    fm_staff: null,
                }
            }
        },
        computed: {
            ...mapGetters({
                sorItem:  'v2SorController/sorItem',
                ClientContractID: 'ContractController/ClientContractID',
                ListingEquiment: 'MaintenanceScheduleController/ListingEquiment',
            })
        },
        created() {
            if(this.$route.params.maintenance_id == 0){
                return this.$router.go(-1);
            }
            if(this.ClientContractID && this.ClientContractID.contract_terms){
                this.rootIds.contract_term_id = this.ClientContractID.contract_terms[0].id;
                this.rootIds.end_date = this.ClientContractID.contract_terms[0].end_date ? moment(this.ClientContractID.contract_terms[0].end_date,'YYYY-MM-DD').toDate() : null;
                this.rootIds.property_root = this.ClientContractID.property_root_id;
            }
            if(this.sorItem.id){
                this.rootIds.contract_term_id = this.sorItem.contract_term_id;
                this.rootIds.contract_id = this.$route.params.id ? this.$route.params.id : this.sorItem.contract_term.contract_id
            }

            if(this.rootIds.contract_id){
                this.loadRootProperty()
            }

            if(parseInt(this.$route.params.maintenance_id) !== 0){
                this.$store.dispatch("v2SorController/getItem",this.$route.params.maintenance_id)
                    .then(response => {
                        if(response.data.data.code && response.data.data.code == 400) {
                            if(this.$route.params.id) {
                                return this.$router.push(`/v2/contract-client/${this.$route.params.id}/maintenance-program`)
                            } else {
                                this.$router.push(`/v2/maintenance-program`)
                            }
                        }
                    });
            }
            this.getSupplier({is_supplier: true, is_fm_company: false });
            this.checkShowBtn();

            //check show modal schedule
            if(this.$route.query.hasOwnProperty('tab') && this.$route.query.tab == 'maint_schedule' && this.$route.query.hasOwnProperty('contract_id') && this.$route.query.hasOwnProperty('schedule_id')) {
                this.getScheduleDetail({
                    contract_id: this.$route.query.contract_id,
                    schedule_id: this.$route.query.schedule_id
                })
            }
        },
        watch: {
            "sorItem": function (val) {
                if(val.id){
                    this.rootIds.contract_term_id = val.contract_term_id;
                    this.rootIds.contract_id = this.$route.params.id ? this.$route.params.id : this.sorItem.contract_term.contract_id;
                    this.loadRootProperty()
                    if(val.property_id) {
                        this.loadEquipmentList(val.property_id);
                    }
                }
            },
            ClientContractID: function(val, old){
                // if(val && old && old.id && val.id !== old.id){
                //     this.$router.push(`/v2/contract-client/${val.id}/maintenance-program`)
                // }
                this.rootIds.contract_term_id = val.contract_terms[0].id;
                this.rootIds.end_date = val.contract_terms[0].end_date ? moment(val.contract_terms[0].end_date,'YYYY-MM-DD').toDate() : null;
                this.rootIds.contract_id = val.id;
                this.rootIds.property_root = val.property_root_id;
                this.loadRootProperty()
                this.checkShowBtn()
            },
            equipmentSelected: function(val) {
                let arr = this.listItemEquipment.filter(item => item.status != 3)
                if(arr.length > val.length) {
                    this.checkAll = false
                }

                if(val.length > 0 && arr.length == val.length) {
                    this.checkAll = true
                }
            },
            startDate: function (val) {
                this.checkDate();
            },
            endDate: function (val) {
                this.checkDate();
            },
            ListingEquiment: function(val) {
                this.listItemEquipment = this.listItemEquipment.filter(function(obj) {
                    let check = val.some(function(obj2) {
                        return obj.id == obj2.id
                    });
                    if (check) {
                        obj.status = 3
                    } else {
                        if(obj.status == 3) obj.status = 0;
                    }
                    return obj;
                });

                if (this.equipmentSelected.length) {
                    this.equipmentSelected = this.equipmentSelected.filter(function(obj) {
                        return val.every(function(obj2)   {
                            return obj.id != obj2.id
                        });
                    });
                }

                if(this.checkAll && (this.equipmentSelected.length != val.length || this.equipmentSelected.length == 0)) {
                    this.checkAll = false
                }
            },
            "modals.assign.checksupplierAssign": function(val) {
                if(val && val == 'No') {
                    this.modals.assign.supplierAssign = null;
                }
            }
        },
        filters: {
            eqlTable: function(value) {
                if (!value) return "N/A";
                let data = value;
                let text = "";
                if (data.length > 2) {
                    text = data[0].name + ", " + data[1].name + " and " + (data.length - 2) + " more";
                } else {
                    let textArr = [];
                    for (let i = 0; i < data.length; i++) {
                        textArr.push(data[i].name);
                    }
                    text = textArr.join(", ")
                }
                return text;
            },
            eqlTableFull: function(value) {
                if (!value) return "N/A";
                let data = value;
                let text = "";
                let textArr = [];
                for (let i = 0; i < data.length; i++) {
                    textArr.push(data[i].name);
                }
                text = textArr.join(", ");
                return text;
            },
        },
        methods: {
            getScheduleDetail(params) {
                this.$store.dispatch("MaintenanceScheduleController/getItem", params)
                .then(response => {
                    if(response.data.data.hasOwnProperty('id')) {
                        this.showDetail(response.data.data);
                    }
                })
                .catch(err => {})
            },
            checkShowBtn() {
                let controls = {
                    disabled_create: false,
                    createTooptip: 'New',
                    delete: this.$checkRole(this.$accessModule.client_contract_program, 'delete'),
                    tableCloneMaster: true,
                    tableCloneMasterIcon: 'img/copy.png'
                }
                if(this.ClientContractID && this.ClientContractID.status == 'Draft') {
                    controls.createTooptip = 'Only availble with ACTIVE contract';
                    controls.disabled_create = true;
                }
                this.tableConfig.controls = controls
            },
            async addItem() {
                if(!this.$checkRole(this.$accessModule.client_contract_program, 'create')){
                    return;
                }
                this.modals.create = true;
                this.checkAll = false
                this.equipmentSelected = [];
                this.itemsEquipmentSchedule = [];
                this.startDate = null;
                this.endDate = null;
                this.property = null;
                this.description = null;
                this.holiday = 1
                this.id = 0;
                this.listItemEquipment = [];
                
                if(this.sorItem.equipment_structure_type){//hard fm
                    if(this.sorItem.property_id) this.loadEquipmentList(this.sorItem.property_id);
                }

                this.properties = [];
            },
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.maintenance_id.value = this.$route.params.maintenance_id;
                await this.$store.dispatch("MaintenanceScheduleController/getItems", tableRequest)
                    .then(response => {
                        let data = {
                            items: response.data.data.items,
                            equipments: response.data.data.equipments,
                            total: response.data.data.total
                        }
                        this.tableItems = data.items;
                        this.tableConfig.total = data.total;
                        resolve(data);
                    })
                    .catch(err => {
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            /*async selectEquips(node) {
                this.nodeSelected = node;
                if(this.sorItem.property_id) {
                    let itemsEquipmentLocation = await global.axios(`api/contracts/${this.rootIds.contract_id}/properties/${this.sorItem.property_id}/equipment`, {
                        method: "GET",
                        params: {
                            equipment_group_id : node.data.id
                        },
                        headers: {
                            Accept: "application/json",
                        }
                    });
                    let ItemEquipment = itemsEquipmentLocation.data.data.filter((obj) => {
                        let check = this.itemsEquipmentSchedule.some(function (obj2) {
                            return obj.id == obj2.id;
                        });
                        check ? obj.status = 1 : obj.status = 0;
                        return obj;
                    });
                    this.listItemEquipment = ItemEquipment.filter((obj) => {
                        let check = this.ListingEquiment.some(function (obj2) {
                            return (obj.id == obj2.id && obj.status == 0)
                        });
                        check ? obj.status = 3 : obj;
                        return obj;
                    });
                }else{
                    this.listItemEquipment = [];
                }
            },*/
            async selectLocation(node) {
                this.nodeSelected = node;
                if(this.sorItem.equipment_group_id) {
                    let itemsEquipmentLocation = await global.axios(`api/contracts/${this.rootIds.contract_id}/properties/${node.data.id}/equipment`, {
                        method: "GET",
                        params: {
                            equipment_group_id : this.sorItem.equipment_group_id,
                            equipment_status: 'Active'
                        },
                        headers: {
                            Accept: "application/json",
                        }
                    });
                    let ItemEquipment = itemsEquipmentLocation.data.data.filter((obj) => {
                        if(this.itemsEquipmentSchedule){
                            let check = this.itemsEquipmentSchedule.some(function (obj2) {
                                return obj.id == obj2.id;
                            });
                            check ? obj.status = 1 : obj.status = 0;
                            return obj;
                        }
                        else{
                            return obj;
                        }
                    });
                    this.listItemEquipment = ItemEquipment.filter((obj) => {
                        let check = this.ListingEquiment.some(function (obj2) {
                            return (obj.id == obj2.id && obj.status == 0)
                        });
                        check ? obj.status = 3 : obj;
                        return obj;
                    });
                }else{
                    this.listItemEquipment = [];
                }
                this.checkAll = false;
            },
            save() {
                /*if(!this.property){
                    return this.$bvToast.toast("Please select a  property", {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    });
                }*/
                let equipment_list = [];
                let equipment_ids = this.listItemEquipment.map(item => item.id);
                for(let i = 0; i < this.listItemEquipment.length;i++){
                    if(this.listItemEquipment[i].status === 1 || this.listItemEquipment[i].status === true){
                        equipment_list.push({
                            id: this.listItemEquipment[i].id,
                            name: this.listItemEquipment[i].tag_name,
                        })
                    }
                }

                /* #4238 Fix: choose a different location from the parent node, equipment current is lost when saving equipment*/
                let equipment_old_list = [];
                if(this.itemsEquipmentSchedule) {
                    equipment_old_list = this.itemsEquipmentSchedule.filter(item => !equipment_ids.includes(item.id))
                }
                equipment_list = equipment_old_list.concat(equipment_list); 

                let property_list=[];
                if(this.properties != null && this.properties.length > 0){
                    for(let i = 0; i < this.properties.length;i++){
                        property_list.push({
                                id: this.properties[i].id,
                                name: this.properties[i].name,
                            });
                    }
                }


                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    let checkdate = this.checkDate(true);
                    if(!checkdate) return;

                    let data = {
                        contract_id: this.rootIds.contract_id,
                        maintenance_id: this.sorItem.id,
                        equipment_group_id: this.sorItem.equipment_group_id,
                        service_category_id: this.sorItem.service_category_id,
                        frequency_id: this.sorItem.frequency_id,
                        skips_holiday: this.holiday,
                        description: this.description,
                        start_date: moment(this.startDate).format('YYYY-MM-DD'),
                        end_date: moment(this.endDate).format('YYYY-MM-DD'),
                        equipment_list: JSON.stringify(equipment_list),
                        property_id: this.sorItem.property_id,
                        property_list: JSON.stringify(property_list),
                        update_jobs: true,
                    }
                    let api = 'saveSchedule';
                    let keyMessage= 'adding'
                    if (this.id) {
                        api = 'updateSchedule';
                        keyMessage = 'editing'
                        data.equipment_list = equipment_list;
                        data.id = this.id
                    }
                    this.isAction = true;
                    this.$store.dispatch(`MaintenanceScheduleController/${api}`, data)
                        .then(result => {
                            this.$refs.gofixTable.reloadTableKeepFilter();
                            this.modals.create = false;
                            this.isAction = false;
                            this.$alertNotification(this.$notificationV2(keyMessage, 'maintenance_schedule'));
                        })
                        .catch(error => {
                            this.isAction = false;
                        })
                }, 300)
            },
            async showDetail(item) {
                this.checkAll = false
                this.itemsEquipmentSchedule = item.equipment_list;
                this.startDate = new Date(item.start_date);
                this.endDate = new Date(item.end_date);
                this.property = item.location_info;
                this.holiday = item.skips_holiday;
                this.description = item.description;
                this.id = item.id;
                this.modals.create = true;
                if(this.sorItem.equipment_structure_type && item.property_list != null && item.property_list.length>0){
                    this.$alertNotification("Maintenance program with equipment type can't have property schedule", "danger");
                    this.modals.create = false;
                    return;
                }
                if(this.sorItem.equipment_structure_type){//hard fm
                    if(this.sorItem.property_id){
                        this.loadEquipmentList(this.sorItem.property_id)
                    }
                    if(item.equipment_list !=null && item.equipment_list.length>0)
                    {
                        this.equipmentSelected = Array.from(item.equipment_list);
                    }
                }
                else{//soft fm
                    if(item.property_list != null && item.property_list.length>0){
                        this.properties = Array.from(item.property_list);
                    }
                    else{
                        this.properties = null;
                    }
                }
            },
            async getDataEquips() {
                let response = await this.$store.dispatch("EquipmentV2Controller/getEquipmentCategory", {
                    id: 0,
                    contract_id: this.$route.params.id
                })
                if (response.data.status == 200) {
                    this.rootID = response.data.data[0].id;
                    return response.data.data
                }
                return []
            },
            async loadEquipmentList(property_id){
                this.loadings.equipment = true;
                let location = await global.axios(`api/contracts/${this.rootIds.contract_id}/properties/${property_id}`, {
                    method: "GET",
                    params: {
                        is_active: true
                    },
                    headers: {
                        Accept: "application/json",
                    }
                });
                location.data.data.data = {
                    id: location.data.data.id,
                }
                location.data.data.state = {
                    selected: true
                };
                if(this.$refs.tree){
                    this.$refs.tree.setModel(location.data.data);
                }
                if(this.sorItem.property_id) {
                    //this.sorItem.property_id
                    let itemsEquipmentLocation = await global.axios(`api/contracts/${this.rootIds.contract_id}/properties/${location.data.data.id}/equipment`, {
                        method: "GET",
                        params: {
                            equipment_group_id : this.sorItem.equipment_group_id,
                            equipment_status: 'Active'
                        },
                        headers: {
                            Accept: "application/json",
                        }
                    });
                    let ItemEquipment = itemsEquipmentLocation.data.data.filter((obj) => {
                        if(this.itemsEquipmentSchedule){
                            let check = this.itemsEquipmentSchedule.some(function (obj2) {
                                return obj.id == obj2.id;
                            });
                            check ? obj.status = 1 : obj.status = 0;
                            return obj;
                        }
                        else{
                            return obj;
                        }
                    });
                    if(this.id) {
                        ItemEquipment = ItemEquipment.filter((obj) => {
                            let check = this.ListingEquiment.some(function (obj2) {
                                return (obj.id == obj2.id && obj.status == 0)
                            });
                            check ? obj.status = 3 : obj;
                            return obj;
                        });
                    }

                    this.listItemEquipment = ItemEquipment;
                    if (this.equipmentSelected.length) {
                        this.equipmentSelected = this.equipmentSelected.filter((obj) => {
                            return this.listItemEquipment.every(function(obj2)   {
                                return obj.id != obj2.id
                            });
                        });
                    }

                }else{
                    this.listItemEquipment = [];
                }
                this.loadings.equipment = false;
            },
            reloadFilterEquipment(val){
                this.loadEquipmentList(val.id)
            },
            addListEquipment(item) {
                if (!item.status) {
                    this.equipmentSelected.push({
                        id: item.id,
                        name: item.tag_name
                    });
                } else {
                    this.equipmentSelected = this.equipmentSelected.filter(function(obj) {
                        return obj.id !== item.id;
                    });
                }
            },
            selectAll() {
                if (this.checkAll) {
                    this.equipmentSelected = [];
                    this.listItemEquipment.forEach((item) => {
                        item.status == 3 ? item.status : item.status = 1;
                        if (item.status != 3) {
                            this.equipmentSelected.push({
                                id: item.id,
                                name: item.tag_name
                            });
                        }
                    });
                } else {
                    this.listItemEquipment.forEach((item) => {
                        item.status == 3 ? item.status : item.status = 0;
                    })
                    this.equipmentSelected = [];
                }
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("MaintenanceScheduleController/deleteSchedule", { ids : ids , contract_id : this.rootIds.contract_id})
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'maintenance_schedule'))
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
            checkDate(flag) {
                let flagDateCheck = false;
                let message = 'Please select start date and end date';
                if (!this.startDate || !this.endDate) {
                    if (flag === undefined) return;
                    flagDateCheck = true;
                } else if(moment(this.startDate).isAfter(moment(this.endDate))) {
                    flagDateCheck = true;
                    message = 'End Date must be greater than Start Date';
                }

                if (flagDateCheck) {
                    this.$alertNotification(message, "danger");
                    return false;
                }


                if(this.sorItem.equipment_structure_type){//hard fm
                    this.isAction = true;
                    this.$store.dispatch(`MaintenanceScheduleController/listItemEquipmentFilter`, {
                        start_date:  moment(this.startDate).format('YYYY-MM-DD'),
                        end_date: moment(this.endDate).format('YYYY-MM-DD'),
                        maintenance_id: this.$route.params.maintenance_id,
                        schedule_id: this.id
                    })
                        .then(result => {
                            this.isAction = false;
                        })
                        .catch(error => {
                            this.isAction = false;
                        })
                }
                return true;
            },
            async modalsRunsheet(){
                this.disabledJob = false
                this.modals.assign.loading = false
                this.modals.assign.checksupplierAssign = 'Yes'
                this.modals.assign.supplierAssign = null
                this.modals.assign.raise_work_order = false
                this.modals.assign.staff_in_charge = null
                this.modals.assign.team_in_charge = null
                this.modals.assign.property_ids = []
                this.modals.assign.service_category_ids = []
                let params = {
                    contract_id: this.rootIds.contract_id ? this.rootIds.contract_id : this.ClientContractID ? this.ClientContractID.id : 0,
                    maintenance_id: this.$route.params.maintenance_id,
                    ids: this.$refs.gofixTable.tableSelected.selected,
                };
                if(!params.contract_id || !params.maintenance_id){
                    this.disabledJob = false
                    return this.$alertNotification("Can't get the contract ID and Maintenance ID", "danger");
                }
                if(params.ids.length == 0){
                    this.disabledJob = false
                    return this.$alertNotification("Please select at least 1 item before update joblist.", "danger");
                }
                
                this.tableItems.forEach(item => {
                    if(params.ids.includes(item.id)) {
                        if(item.service_category_id) {
                            this.modals.assign.service_category_ids.push(item.service_category_id)
                        }
                    }
                })
                this.tableItems.forEach(item => {
                    if(params.ids.includes(item.id)) {
                        if(item.property_list) {
                            item.property_list.forEach(info => {
                                if(info.id) {
                                    this.modals.assign.property_ids.push(info.id)
                                }
                            })
                        }
                    }
                })
                if(!this.modals.assign.property_ids) {
                    if(this.sorItem.property_id) {
                        this.modals.assign.property_ids.push(this.sorItem.property_id)
                    }
                }
                this.getFMTeam();
                this.getFMStaff();
                this.modals.assign.open = true;
            },
            showMoreSupplier(){
                switch (this.tierLevel) {
                    case 1:
                        this.modals.assign.supplier = this.modals.assign.supplier.concat(this.tiers.tier_2);
                        this.tierLevel = 2;
                        break;
                    case 2:
                        this.modals.assign.supplier = this.modals.assign.supplier.concat(this.tiers.tier_3);
                        this.tierLevel = 3;
                        break;
                }
            },
            getSupplier(){
                this.$store.dispatch("MiscExpensesController/getRelateSupplier",{
                    contract_id: this.rootIds.contract_id ? this.rootIds.contract_id : this.ClientContractID ? this.ClientContractID.id : 0,
                    filter:null
                })
                    .then(response => {
                        this.tiers = response;
                        if(response.tier_1){
                            this.modals.assign.supplier = response.tier_1;
                            this.tierLevel = 1;
                        }else if(response.tier_2){
                            this.modals.assign.supplier = response.tier_2;
                            this.tierLevel = 2;
                        }else if(response.tier_3){
                            this.modals.assign.supplier = response.tier_3;
                            this.tierLevel = 3;
                        }
                    })
                    .catch( err => {
                        console.log(err)
                    })
            },
            showModalInfoGenerate() {
                if((this.modals.assign.checksupplierAssign === 'Yes' || this.modals.assign.raise_work_order) && this.modals.assign.supplierAssign == null){
                    return this.$alertNotification("Please select a supplier!", "danger");
                }

                if(this.modals.assign.loading) return;
                this.modals.assign.loading = true;
                this.$store.dispatch("JobController/checkBeforeGenerateJobAndOrder", this.$refs.gofixTable.tableSelected.selected)
                .then(response=>{
                    this.modals.generateJob.data = Object.assign(this.modals.generateJob.data, response.data.data.data)
                    this.modals.generateJob.data.count_maint_schedule = this.$refs.gofixTable.tableSelected.selected.length
                    this.modals.assign.loading = false;
                    this.modals.assign.open = false;
                    this.modals.generateJob.open = true;
                }).catch(err => {
                    console.log(err);
                    this.modals.assign.loading = false;
                })
            },
            updateRunsheet(){
                let params = {
                    contract_id: this.rootIds.contract_id ? this.rootIds.contract_id : this.ClientContractID ? this.ClientContractID.id : 0,
                    maintenance_id: this.$route.params.maintenance_id,
                    ids: this.$refs.gofixTable.tableSelected.selected,
                    supplier_id: 0,
                    supplier: '',
                    raise_work_order: this.modals.assign.raise_work_order || false,
                    staff_in_charge_id: this.modals.assign.staff_in_charge ? this.modals.assign.staff_in_charge.user_id : null,
                    staff_in_charge_name: this.modals.assign.staff_in_charge ? this.modals.assign.staff_in_charge.user_name : null,
                    team_in_charge_id: this.modals.assign.team_in_charge ? this.modals.assign.team_in_charge.id : null,
                    team_in_charge_name: this.modals.assign.team_in_charge ? this.modals.assign.team_in_charge.group_name : null,
                };
                if(this.modals.assign.checksupplierAssign === 'Yes' && this.modals.assign.supplierAssign){
                    params.supplier_id = this.modals.assign.supplierAssign.id
                    params.supplier = this.modals.assign.supplierAssign.name
                }
                this.modals.generateJob.loading = true;
                this.disabledJob = true
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                console.log(params);
                this.timer = setTimeout(() => {
                    this.$store.dispatch("JobController/generalItems",params).then(data=>{
                        this.disabledJob = false
                        this.modals.generateJob.loading = false;
                        this.modals.generateJob.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        return this.$alertNotification(this.$notificationV2('editing', 'job_list'));
                    })
                }, 500)
            },
            loadOptionsProperties({ action, parentNode, callback,instanceId  }){
                simulateAsyncOperation(async () => {
                    parentNode.children = await this.getProperty(parentNode.data.id, this.rootIds.contract_id)
                    callback()
                })
            },
            getProperty(property_root_id, contract_id) {
                return new Promise (( resolve, reject ) => {
                    global.axios(`api/contracts/${contract_id}/tree-properties/${property_root_id}`, { method: "GET", headers: { Accept: "application/json", } })
                        .then(response => { resolve(response.data.data) }).catch(error => {});
                });
            },
            normalizerProperties(node) {
                if (node.data.isBatch)
                    return {
                        id: node.id,
                        label: node.name,
                        children: node.children
                    };
                return {
                    id: node.id,
                    label: node.name,
                    children: undefined
                };
            },
            loadRootProperty(){
                this.loadings.property = true;
                global.axios(`api/contracts/${this.rootIds.contract_id}/tree-properties/0`, {
                    method: "GET",
                    data: {},
                    headers: {
                        Accept: "application/json",
                    }
                })
                    .then(result => {
                        this.propertiesData = result.data.data;
                        this.loadings.property = false;
                    })
            },
            getFMTeam() {
                this.fm_group_options = [];
                this.$store.dispatch("UserGroupController/getItems", {
                        page: 1,
                        limit: -1,
                        filter: {
                            contract_id: this.rootIds.contract_id
                        }
                    })
                    .then(response => {
                        this.fm_group_options = response.items;
                    })
                    .catch(err => {
                        this.fm_group_options = [];
                    })
            },
            
            getFMStaff(search) {
                this.fm_staff_options = [];
                this.modals.assign.loading_fm_staff = true;
                if (this.timer_c.fm_staff) {
                    clearTimeout(this.timer_c.fm_staff);
                    this.timer_c.fm_staff = null;
                }
                this.timer_c.fm_staff = setTimeout(() => {
                    var params = {
                            contract_id: this.rootIds.contract_id,
                            property_ids: this.modals.assign.property_ids ? this.modals.assign.property_ids : null,
                            service_category_ids: this.modals.assign.service_category_ids ? this.modals.assign.service_category_ids : null,
                            section_name: ["Preventive Maintenance"],
                            module_name: ["Job List"],
                            filter: {
                                name: search || null
                            }
                        };
                    if(this.modals.assign.team_in_charge){
                        params.group_id = this.modals.assign.team_in_charge.id;
                    }
                    this.$store.dispatch("v2UserController/getAccessRunsheetFmUsers", params)
                        .then(response => {
                            this.fm_staff_options = response.items;
                            this.modals.assign.loading_fm_staff = false;
                        })
                        .catch(err => {
                            this.modals.assign.loading_fm_staff = false
                        })
                }, 500);
            },
            FMTeamChange(id){
                this.modals.assign.staff_in_charge = null;
                this.fm_staff_options = [];
                this.getFMStaff();
            },
            getIdSelected(ids) {
                this.modals.clone.ids = ids;
            },
            cloneData() {
                if ( this.modals.clone.ids.length == 0 ) {
                    return this.$alertNotification('Please select one line to clone', 'danger');
                }

                this.endDate = null
                this.startDate = null

                this.modals.clone.open = true
            },
            saveClone() {
                if ( this.modals.clone.ids.length == 0 ) {
                    return this.$alertNotification('Please select one line to clone', 'danger');
                }

                if ( !this.startDate || !this.endDate ) {
                    return this.$alertNotification('Please select start date and end date', 'danger');
                }

                this.modals.clone.loading = true;

                let start_date_ = moment(this.startDate).format('YYYY-MM-DD')
                let end_date_ = moment(this.endDate).format('YYYY-MM-DD')

                this.$store.dispatch('MaintenanceScheduleController/cloneSchedule', { 
                    'contract_id': this.rootIds.contract_id, 
                    'ids': this.modals.clone.ids, 
                    'start_date': start_date_,
                    'end_date': end_date_,
                    'maintenance_id': this.$route.params.maintenance_id
                })
                .then(result => {
                    this.modals.clone.open = false;
                    this.modals.clone.loading = false;
                    this.modals.clone.ids = []

                    this.$alertNotification(result.data.data, "success");

                    this.$refs.gofixTable.reloadTableKeepFilter();
                })
                .catch(error => {
                    this.modals.clone.loading = false;

                    if(error.response && error.response.data.error.message.error) {
                        this.$alertNotification(error.response.data.error.message.error, "danger");
                    }
                });
            }
        },
    }
</script>
